import { Button, ReplaceAllInstances, formatMoney } from '@itarget/shared'
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { useState } from 'react'
import CurrencyField from '../CurrencyField'
import { useStyles } from './styles'
import { useTranslation } from './translation'

const CashbackWallet = ({
  balance = 0,
  totalToSpend = 0,
  balanceUsed = 0,
  cashbackSymbol = 'R$',
  onApplyCashback,
  handleCleanAppliedCashbackWallet,
}) => {
  const { toReal } = formatMoney
  const styles = useStyles()
  const translation = useTranslation()
  const [amountFromWallet, setAmountFromWallet] = useState('')
  const [utilizeWallet, setUtilizeWallet] = useState(true)

  const handleChangeAmountFromWallet = (value) => {
    setAmountFromWallet(value)
  }

  const handleChangeCheckboxUtilizeWallet = (changeEvent) => {
    handleCleanAppliedCashbackWallet()
    const checked = changeEvent.target.checked
    setUtilizeWallet(checked)
  }

  const currentBalance = balance - balanceUsed
  const formattedBalance = toReal(currentBalance)
  const maxTotalToSpend = totalToSpend - balanceUsed
  const formattedTotalToSpend = toReal(maxTotalToSpend)
  const maxInsertToSpend =
    currentBalance > maxTotalToSpend ? maxTotalToSpend : currentBalance
  const redemptionLimitTranslation = !!balanceUsed
    ? translation.redemptionLimitValueWithUsed
    : translation.redemptionLimitValue
  const redemptionLimitText = ReplaceAllInstances(redemptionLimitTranslation, [
    `${cashbackSymbol} ${formattedTotalToSpend}`,
  ])

  const handleApplyCashback = () => {
    if (!amountFromWallet) return
    onApplyCashback && onApplyCashback(amountFromWallet)
    setAmountFromWallet('')
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.activeWalletContainer}>
        <Typography className={styles.title}>{translation.title}</Typography>

        <FormControlLabel
          control={<Checkbox />}
          checked={utilizeWallet}
          className={styles.checkbox}
          label={translation.checkboxLabel}
          onChange={handleChangeCheckboxUtilizeWallet}
        />
      </Box>
      <Box
        className={`${styles.utilizeWalletContainer} ${utilizeWallet ? '' : styles.displayNone}`}
      >
        <Box className={styles.balanceContainer}>
          <Typography className={styles.balanceLabel}>
            {translation.balance}
          </Typography>
          <Typography className={styles.balance}>
            <span className={styles.balanceSymbol}>{cashbackSymbol}</span>
            {formattedBalance}
          </Typography>
        </Box>

        <Box className={styles.redemptionLimitContainer}>
          <Typography className={styles.redemptionLimitLabel}>
            {redemptionLimitText}
          </Typography>
        </Box>

        <Box className={styles.redemptionContainer}>
          <Typography className={styles.redemptionLabel}>
            {translation.redemptionLabel}
          </Typography>
          <Box className={styles.interactiveContainer}>
            <CurrencyField
              max={maxInsertToSpend}
              symbol={cashbackSymbol}
              value={amountFromWallet}
              className={styles.currencyField}
              onChange={handleChangeAmountFromWallet}
            />
            <Button
              icon="currency_exchange"
              className={styles.button}
              onClick={handleApplyCashback}
            >
              {translation.applyCashback}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CashbackWallet
